import { DateRange, DayPicker } from 'react-day-picker';

import { endOfDay } from 'date-fns';
import ResetIcon from 'icons/reset.svg?react';

import Button from '../../shared/Button/Button';

export const DateRangePicker = ({
  selected,
  setSelected,
}: {
  selected: DateRange;
  setSelected: ({ dateRange }: { dateRange: DateRange }) => void;
}) => {
  const onChangeDateRange = (range: DateRange) => {
    setSelected({
      dateRange: { from: range.from, to: range.to ? endOfDay(range.to) : undefined },
    });
  };

  const reset = () => {
    setSelected({
      dateRange: {
        from: undefined,
        to: undefined,
      },
    });
  };

  return (
    <div>
      <Button
        prefixIcon={<ResetIcon className="text-white-100" width={24} height={24} />}
        onClick={reset}
        label={''}
        size="xs"
        variant="transparent"
        isIcon
        className="absolute right-[80px] top-4 z-10"
      />
      <DayPicker
        mode="range"
        onSelect={onChangeDateRange}
        required
        selected={selected ?? undefined}
      />
    </div>
  );
};
